module.exports = __webpack_public_path__ + "img/subs-dressing.b3146142.png";